<template>
  <div class="price-search">
    <div class="header flex-container flex-row flex-horiz-apart flex-verti-center mg-bt-md" @mousedown="dragOnGcs">
      <span class="header-title">价格查询</span>
      <i class="icon-close gjw-iconfont gjw-icon-close" @click="closeSearch" ></i>
    </div>
   <div class="main">
    <div class="filters">
      <div class="name-filter flex-container flex-row flex-verti-center mg-bt-md">
        <span class="name-label">名称</span>
        <el-input class="flex-item flex-item-grow flex-item-shrink" v-model="filters.name" clearable />
      </div>
      <el-form :model="filters" inline label-width="70px" label-position="left" class="flex-container flex-row flex-wrap">
          <template v-for="item in formItems" >
            <el-form-item :label="item.label" :key="item.code">
              <search-form-items :form-item="item" :initValue="filters[item.code]" :number-func="handleNumber" @change="searchDataChange"/>
            </el-form-item>
          </template>
      </el-form>
      <div class="area-filter flex-container flex-row flex-verti-center">
        <span class="name-label">地区</span>
        <el-cascader ref="citySelect" v-model="filters.areaCode" :options="areaTree" :props="{value:'code',label:'name', checkStrictly: true }" separator="-" popper-class="garch-popper" />
      </div>
      <div class="search-button">
        <el-button type="primary" @click="searchPrice">查询价格</el-button>
        <el-button v-if="showContact" type="primary" @click="$emit('click-contact')">联系厂家</el-button>
      </div>
    </div>
    <div
      class="goods-table"
      v-load-more.expand="{func: loadData, target: '.th-body', delay: 300, distance: 10}"
      :load-more-disabled="stopLoadData"
      >
      <div class="th-header flex-container flex-row flex-verti-center">
        <div class="th width-120">商品名称</div>
        <div class="th width-120">规格</div>
        <div class="th width-64">品牌</div>
        <div class="th width-40">单位</div>
        <div class="th width-90">
          <span>价格（元）</span>
          <el-tooltip effect="dark" content="含税市场价" placement="right-end">
            <i class="tishi gjw-iconfont gjw-icon-tishi transition-200" ></i>
          </el-tooltip>
        </div>
        <div class="th width-76">供应商</div>
      </div>
      <div class="th-body ">
          <div v-if="goodsList.length" class="goods-list" >
            <goods-item v-for="(goods,index) in goodsList" :key="index" :goods="goods" :track-name="trackInfo.itemEventName" />
          </div>
          <div v-else class="empty-goods-list flex-container flex-column flex-horiz-center">
            <img class="empty-img" src="@/assets/image/data_empty.png" alt="" width="80">
            <div class="empty-info">
              暂时未能查询到符合条件的商品价格，可以放宽搜索条件试一试
            </div>
          </div>
          <gjw-loading v-if="goodsLoading"></gjw-loading>
      </div>
    </div>
    <div class="meta-info">
      <span>（*以上价格信息来源于广材网）</span>
    </div>
   </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SearchFormItems from '@/components/business/SearchFormItems.vue'
import GoodsItem from './Item.vue'
import GjwLoading from '@/components/lib/GjwLoading.vue'
import GoodsSearch from '@/core/goodsSearch'
export default {
  name: '',
  components: {
    SearchFormItems,
    GoodsItem,
    GjwLoading,
  },
  props: {
    trackInfo: [Object],
    showContact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 筛选条件
      filters: {
      },
      // 数组
      formItems: [],
      payload: null, // 获取商品的body
      goodsLoading: false,
      pageNo: 0,
      pageSize: 30,
      goodsList: [],
      totalCount: 0,
      condition: {}
    }
  },
  computed: {
    ...mapGetters({
      areas: 'goods/areas',
      areaTree: 'goods/areaTree',
      propertyDefinition: 'goods/propertyDefinition'
    }),

    stopLoadData() {
      if (this.goodsList) {
        return this.totalCount <= this.goodsList.length
      }
      return false
    }
  },

  methods: {
    async init(condition) {
      this.condition = condition
      const { filters, filterItems } = new GoodsSearch(this.propertyDefinition, this.areas, condition)
      this.filters = filters
      this.formItems = filterItems
      await this.searchPrice()
    },
    handleNumber(value) {
      value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{3,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{3}).*$/g, '$1')
      return value
    },
    searchDataChange(item) {
      this.filters = Object.assign(this.filters, item)
    },

    async loadData() {
      try {
        if (this.stopLoadData) return
        this.pageNo += 1
        this.payload.pageNo = this.pageNo
        this.goodsLoading = true
        const { list, totalCount } = await this.$api.goods.list(this.payload)
        this.goodsList = [...this.goodsList, ...list]
        this.totalCount = totalCount
      } catch (error) {
        this.goodsList = []
      } finally {
        this.goodsLoading = false
        this.trackPriceSearch()
      }
    },
    async searchPrice() {
      try {
        this.goodsList = []
        this.goodsLoading = true
        this.pageNo = 1
        this.handleFilters()
        const { list, totalCount } = await this.$api.goods.list(this.payload)
        this.goodsList = list
        this.totalCount = totalCount
      } catch (error) {
        this.goodsList = []
      } finally {
        this.goodsLoading = false
        this.trackPriceSearch()
      }
    },
    handleFilters() {
      const filters = this.filters
      const conditionArr = Object.keys(this.condition)
      const body = conditionArr.reduce((obj, c) => {
        if (!['areaName', 'propertyValues', 'platform'].includes(c) && filters[c]) {
          obj[c] = filters[c]
        } else if (c === 'areaName') {
          obj.areaCode = filters.areaCode.at(-1)
        }
        return obj
      }, {})
      if (this.propertyDefinition) {
        body.categoryProperties = this.propertyDefinition.reduce((arr, cp) => {
          const value = filters[cp.code]
          if (Array.isArray(value)) {
            const [firstValue, secondValue] = value
            if (firstValue || secondValue) {
              if (Number(firstValue) < Number(secondValue) || !firstValue || !secondValue) {
                const valueStr = value.join('-')
                arr.push({
                  code: cp.code,
                  value: valueStr
                })
              }
            }
          } else if (value) {
            arr.push({
              code: cp.code,
              value
            })
          }
          return arr
        }, [])
      }
      body.pageNo = this.pageNo
      body.pageSize = this.pageSize
      this.payload = body
    },
    trackPriceSearch() {
      let params = {}
      const { eventName, g_c_material_id, g_c_product_id, g_c_source, categoryName } = this.trackInfo
      const { name, categoryCode, categoryProperties } = this.payload
      const gcProperty = categoryProperties.reduce((obj, ca) => {
        obj[ca.code] = ca.value
        return obj
      }, {})
      // 打点需要的地区是整个层级
      const district = this.condition.areaName || '全国'
      if (eventName === 'materialPriceQuery') {
        params = {
          g_c_material_id,
          g_c_material_name: name,
          g_c_class_code: categoryCode,
          g_c_class_name: categoryName,
          g_c_district: district,
          g_c_property: gcProperty,
          g_c_result_count: this.totalCount,
          g_c_source,
        }
      } else {
        params = {
          g_c_product_id,
          g_c_product_name: name,
          g_c_class_code: categoryCode,
          g_c_class_name: categoryName,
          g_c_district: district,
          g_c_property: gcProperty,
          g_c_result_count: this.totalCount
        }
      }
      this.$tracks({
        event: eventName,
        params
      })
    },
    closeSearch() {
      this.$emit('close-search')
    },
    dragOnGcs(e) {
      // 事件捕获导致不能触发click
      if (e.target.tagName.toLocaleLowerCase() !== 'i') {
        this.$emit('drag-tab')
      }
    }
  },
}
</script>
<style lang='less' scoped>
/deep/.el-form-item--mini.el-form-item{
  margin-bottom: 8px;
}
/deep/.el-drawer__body{
  overflow: hidden;
}
.price-search{
  background: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header{
    padding: 12px 16px;
    border-bottom: 1px solid @theme-border-color;
  }
  .header-title{
    font-size: 1.1429rem;
  }
  .icon-close{
    cursor: pointer;
    font-size: 12px;
  }
  .name-label{
    display: inline-block;
    box-sizing: border-box;
    min-width: 70px;
    padding-right: 8px;
  }
  .main{
    padding: 0 16px;
  }
}
.main{
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}
.filters{
  padding-bottom: 8px;
}
.search-button{
  text-align: right;
}
.goods-table{
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  overflow: hidden;
  border: 1px solid @theme-border-color;
  .th-header{
    flex-shrink: 0;
    background-color: @bg-grey-dark;
    padding: 8px;
    color: #50505A;
  }
  .tishi{
    color: @theme-grey-3;
    font-size: 12px;
    &:hover{
      color: @theme-hover-color;
    }
  }
  .th-body{
    flex-grow:1;
    overflow: auto;
  }
  .empty-goods-list{
    height: 100%;
    padding-top: 70px;
    .empty-info{
      text-align: center;
    }
  }
}
/deep/ .el-form-item__label{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.meta-info{
  padding: 6px 0;
  color: @theme-text-light;
}

</style>
